function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 206 149"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  opacity: ".18",
  d: "M111.06 18c-18.66 2.98-37.66 3-56.47 4.82-9.73.93-64.27 28.6-53.1 87.43 4.1 21.67 25.82 39.24 47.86 38.27 18.72-.81 20.78-13.15 54.14-13.85 25.33-.53 44.86 17.55 74.2 7.11 13.01-4.62 23.38-16.29 26.7-29.68 3.32-13.4-1.5-28.87-12.83-36.77-5.88-4.11-13.38-6.34-17.57-12.17-8.2-11.43 8.41-29.11 1.02-41.08-14.69-23.81-48.3-6.6-63.95-4.09z"
})), /*#__PURE__*/React.createElement("path", {
  opacity: ".05",
  d: "M45.39 34.8s-19.71-4.9-2.65-11.96c17.07-7.06 96.29-14.86 125.3 1.12 0 0 19.88.55 20.43 3.34.54 2.79-2.36 5.04-2.36 5.04l-10.1.35s-1.85-4.03-11.14 3.28c-9.3 7.3-119.48-1.17-119.48-1.17z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M165.54 34.76c0-8.6-26.8-15.58-59.87-15.58-33.07 0-59.88 6.98-59.88 15.58a4.85 4.85 0 001 2.84c5.13 7.25 29.54 12.74 58.88 12.74 29.34 0 53.75-5.49 58.88-12.74.62-.82.97-1.81 1-2.84z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".05",
  d: "M164.13 37.6c-5.13-7.25-29.54-12.73-58.87-12.73-29.34 0-53.75 5.48-58.89 12.73 5.13 7.25 29.54 12.74 58.89 12.74 29.34 0 53.74-5.5 58.87-12.74z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".05",
  d: "M105.42 30.6c27 0 48.9 4 48.9 8.92s-21.9 8.92-48.9 8.92-48.9-4-48.9-8.92 21.9-8.92 48.9-8.92z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M147.68 40.44s3.43-7.5-40.65-7.78h-2.55c-11.75 0-20.25.61-26.4 1.5h-.02c-15.73 2.23-16.03 6.26-16.03 6.26L33.6 146.01l45.64.18 95.17.37-26.72-106.12z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M52.78 42.42l-.13-.1c-.1-.06-.2-.15-.32-.24-.34-.28-.66-.59-.97-.91-.89-.95-1.42-1.91-1.43-2.82 0-.42.12-.83.34-1.18l.02.19-1.44-1.4-.12-.1.12-.1 3.52-3.18.07-.06.08.04 4.19 1.76h-.1l.07-.03.2-.1.75-.3a90.96 90.96 0 013.23-1.26c1.6-.59 2.84-.96 3.58-1.06l-.12.2-1.86-5.86-.04-.14.13-.05 3.2-1.11-.1.13.05-1.67h.3l-.05 1.67v.1l-.1.04-3.2 1.11.1-.18 1.86 5.85.05.17-.17.02c-.71.1-1.94.46-3.52 1.04l-.82.3c-.8.3-1.61.63-2.4.95l-.75.32-.2.08-.07.03-.06.03-.06-.03-4.18-1.76.15-.02-3.52 3.16v-.22l1.44 1.4.09.08-.07.1c-.2.3-.3.65-.3 1.01 0 .82.5 1.72 1.36 2.63a10.6 10.6 0 001.25 1.13l.12.1-.17.24zM67.04 28.97l.19-.03.53-.08 1.94-.3a446.57 446.57 0 019.4-1.32c4.78-.6 8.4-.94 10.4-.9h.1l.03.08 1 2.41-.15-.09h.08l.23-.01.84-.06a394.77 394.77 0 015.03-.27c2.23-.1 3.97-.15 5.04-.12l-.15.14.47-6.96v-.14h.77l1.68.02c1.75.03 3.48.07 5.1.12 4.06.13 6.7.32 7.33.6l.1.04v.1l-.2 2.8-.05-.14 4.92 3.24-.07-.02h.13l.4.03 1.36.1c1.43.12 2.85.25 4.18.4 2.83.3 4.83.63 5.68.96l-.2.1.72-2.83.02-.08.08-.03 8.18-2.32h.07l6.88 1.5-.12.03 1.5-1.21.18.23-1.5 1.2-.05.05-.07-.02-6.88-1.5h.08l-8.19 2.33.1-.1-.71 2.85-.04.16-.16-.06c-.81-.32-2.8-.64-5.6-.94a148.7 148.7 0 00-5.54-.5l-.38-.03h-.14l-.07-.02-4.93-3.24-.07-.05V25l.18-2.79.1.15c-.6-.25-3.25-.45-7.24-.58-1.62-.05-3.35-.1-5.09-.12l-1.67-.02h-.64l.15-.14-.47 6.96v.14h-.11c-1.06-.02-2.8.02-5.03.12a233.85 233.85 0 00-5.02.28l-.84.05-.23.02h-.19l-.03-.1-1-2.41.13.09c-1.97-.03-5.59.3-10.36.9a317.36 317.36 0 00-9.39 1.32l-1.94.3-.53.09-.18.03-.07-.32z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M96.55 19.42l-2.94 3.92-.05.06h-.07c-1.06-.12-4.61.1-9.84.59l-2.2.2c-1.87.18-3.77.37-5.6.57l-1.75.18-.48.06-.17.01h-.06l-.04-.03-3.3-2.4.18-.23 3.29 2.38-.1-.03.16-.02.48-.05 1.75-.19 5.6-.56 2.2-.2c5.27-.49 8.82-.72 9.9-.6l-.13.07 2.94-3.9.23.17zM159.79 28.37l.06 3.03-.08-.12.16.09.42.26c.45.3.87.64 1.26 1a5.27 5.27 0 011.83 3.17l-.13-.13 1.61.12-.02.3-1.61-.13h-.12l-.02-.12a4.97 4.97 0 00-1.74-3 9.52 9.52 0 00-1.78-1.3l-.08-.03v-.1l-.06-3.04h.3zM57.14 44.22a2.49 2.49 0 01-.16-.1l-.4-.28c-.43-.32-.84-.68-1.22-1.06-1.46-1.48-2.15-3.1-1.62-4.8l.28.09c-.49 1.57.16 3.1 1.55 4.5a9.9 9.9 0 001.73 1.4l-.16.25zM47.05 38.86a2.2 2.2 0 01-.22-.46c-.3-.86-.3-1.79.03-2.64.47-1.38 1.61-2.8 3.56-4.25a34.88 34.88 0 015.65-3.01l-.08.09L57 25.43l.28.09-1 3.15-.03.06-.06.03a34.45 34.45 0 00-5.6 2.99c-1.9 1.4-3 2.78-3.45 4.1a3.56 3.56 0 00.1 2.74l.05.1-.24.17zM159.66 40.9l.05-.06c.02-.04.1-.12.14-.2.16-.22.31-.46.45-.7.58-1.08.81-2.18.5-3.2-.4-1.25-1.6-2.3-3.81-3.03a288.24 288.24 0 00-10.4-3.25l-.56-.16-.2-.05.15-.04-2.1 2.05-.04.05h-.08l-4.7-.56.1-.03-1.49 1.36-.2-.22 1.5-1.36.05-.05h.08l4.72.56-.13.04 2.1-2.05.06-.06.08.02.2.05.55.16 2.18.64c2.38.72 5.14 1.6 8.23 2.62 2.3.76 3.57 1.87 3.98 3.23.34 1.1.1 2.27-.52 3.42a6.98 6.98 0 01-.68 1.02l-.21-.2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M105.67 32.58l-18.83.64c-.22.01-5.38.66-12.08 1.58-2.61.36-11.9 3.12-12.72 5.62L33.6 146l45.64.18 26.42-113.53.02-.08z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M186.5 134.7a6.71 6.71 0 01-4.86 2.54c-2.64 0-1.36-2.48-.5-2.48.25.01.5-.01.74-.06l1.08-.95 1.08-.96.28-.61s1.5.34 1.76-.05l.2 1.68v.32c.12.17.2.37.22.57zM180.01 134.57c0 .25-2.64 1.76-5.23 1.76-2.6 0-1.37-2.5-.49-2.47h.88l.5-.25 1.9-.97.28-.6s1.5.34 1.76-.06l.2 1.7v.32c.11.17.18.37.2.57z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M179.83 134c.1.18.14.38.14.58 0 .25-2.64 1.76-5.23 1.76-2.6 0-1.37-2.5-.49-2.47h.88l.5-.25 4.16.07.04.3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M176.19 135.38c-.64.16-1.3.16-1.94 0-.58-.32-.76-.56-.75-.8.02-.24.37-.95 1.76-.62 1.4.34 1.65 1.09 1.65 1.09l-.72.33zM186.5 134.7a6.71 6.71 0 01-4.86 2.54c-2.64 0-1.36-2.48-.5-2.48.25.01.5-.01.74-.06l1.08-.95 3.34.06v.32c.11.17.18.37.2.57z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M183.11 136.16c-.63.17-1.3.17-1.93 0-.59-.31-.77-.55-.75-.8.02-.24.37-.95 1.76-.61 1.4.33 1.68 1.04 1.68 1.04l-.76.37z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M174.6 105.87l2.64 26.1s1.76.64 2.54 0l1.1-20.55 3.09 20.73s1.44.94 2.33-.12l1.15-26.3s-9.22 1.9-12.85.14z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M174.6 105.65l2.64 26.1s1.76.64 2.54 0l1.1-20.55 3.09 20.73s1.44.93 2.33-.13l1.15-26.3s-9.22 1.9-12.85.15z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M183.85 81.18c.35.27.72.5 1.11.7.93.53 1.94.91 3 1.11 1.38.15 1.96 2.74 2.14 3.96.19 1.22 1.46 7.28 1.46 7.28a2.46 2.46 0 01-1.96 2.6c-2.24.72-2.18 1.09-2.18 1.09l.04 7.77s-10.1 2.46-12.84.15l.4-10.53 1.5-11.44 4.28-2 3.05-.7z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M183.85 81.18c.35.27.72.5 1.11.7.93.53 1.94.91 3 1.11 1.38.15 1.96 2.74 2.14 3.96.19 1.22 1.46 7.28 1.46 7.28a2.46 2.46 0 01-1.96 2.6c-2.24.72-2.18 1.09-2.18 1.09l.04 7.77s-10.1 2.46-12.84.15l.4-10.53 1.5-11.44 4.28-2 3.05-.7z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M183.87 80.95a2.64 2.64 0 01-3.5 1.28l-.11-.05s-2.19 3.8.94 3.35c1.66-.25 2.74-2.87 3-4.11l-.33-.47z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".05",
  d: "M184.59 94.02c.8-.2 1.61-.43 2.4-.71.27-.19-.4-5.15-.4-5.15s-.25 3.99-5.35 5.9c-2.5.93 1.7 2.2 1.7 2.2l1.65-2.24z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".05",
  d: "M184.09 97.28s2.76 1.02 3.3.66v6.08s-7.04-4.57-7.04-5.29c0-.7-5.4-.87-5.4-.87v-1.67l8.19-.96s1.77-1.54.95 2.05z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M184.56 93.93s0 2.5-.38 3.2c-.38.71-.62-1.76-.62-1.76l1-1.44z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M184.03 77.92l-.07 1.3c-.03.6-.08 1.35-.1 1.96a4.13 4.13 0 01-1.27 2.76c-.44.45-.96.8-1.54 1.04a.82.82 0 01-1.06-.97 5.7 5.7 0 00.16-3.01c-.47-1.2 3.37-2.87 3.83-3.07l.05-.01z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M183.99 77.93c-.2.55-.25 1.66-1.1 2.74-.37.5-1.4 1.62-2.62 1.9a5.33 5.33 0 00-.12-1.57c-.46-1.19 3.38-2.87 3.84-3.07z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M180.23 70.48a4.17 4.17 0 00-3.93 4.7c.13 1.69.57 3.34 1.29 4.88 1.37 2.33 4.81.42 5.36-.54.54-.96 2.64-5.28 1.76-6.5-.58-.8-2.24-2.62-4.48-2.54z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M176.59 68.87l.68.36a2.65 2.65 0 00-2.15 1.02 3.51 3.51 0 00-1.03 2.43l1.21-.58s-.09 1.48 2.19 1.6c2.27.11 4.68.2 4.68.2l-.77-1.07s1.43.58 1.66 1.1c.22.83.38 1.68.48 2.54 0 0 .57-1.45.79-1.14.22.32-.25 1.64-.55 1.94-.3.3-.25 1.16-.27 1.23-.02.07 1.41-1.11 1.48-1.52.07-.4 1.5-4.55.57-5.41l.58-.05a2.75 2.75 0 00-1.12-.43s-3.75-4.89-8.43-2.22z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M176.52 83.93s-1.77.78-2 4.24c-.19 2.23-.6 4.45-1.23 6.6-1.33.13-2.67.2-4 .2l1.95 1.5c.73.56 1.58.94 2.49 1.11l1.35.3 1.44-13.95z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M183.05 95.83v.1a.72.72 0 01-.75.62l-13.2-.75a.69.69 0 01-.33-.1.7.7 0 01-.38-.38l-2.89-8.22a.72.72 0 01.36-.89c.1-.05.22-.08.34-.07l9.17.16a.72.72 0 01.68.52l2 7.22a.73.73 0 00.6.52l3.75.55a.72.72 0 01.65.72z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M183.05 95.83v.1a.72.72 0 01-.75.62l-13.2-.75a.69.69 0 01-.33-.1.7.7 0 01-.38-.38l-2.89-8.22a.72.72 0 01.36-.89c.1-.05.22-.08.34-.07l9.17.16a.72.72 0 01.68.52l2 7.22a.73.73 0 00.6.52l3.75.55a.72.72 0 01.65.72z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M184.46 95.42a1 1 0 01-.65 0 2.56 2.56 0 01-.63-.22c-.36-.2-1.15-.92-1.89-.71-.65.15-1.33.19-2 .1-.26-.06-.26-.13-.53-.1-.26.03-.25-.32-.25-.32.8-.52 1.66-.93 2.56-1.22.9.02 1.8.2 2.65.54l.57.33.03.02.31.18s.02 1.26-.17 1.4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M181.78 92.97l-1.22-.66s-.2.33-.08.5c.06.08.14.16.22.23.35-.1.72-.12 1.08-.07z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M172.47 96c.46.6 1.1 1.04 1.84 1.24 1.32.42 3.69-.44 3.69-.44s.77-.35.63-.43c-.14-.08-3.95-.23-3.95-.23l-2.2-.14z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M175.18 133.86s.88.45.93 1.14l.07.38s3.3-.63 3.68-1.38l-.16-1.16a1.7 1.7 0 01-1.51.54c-.78-.24-.63-.75-.63-.75l-2.38 1.23zM182.18 134.85l-.3-.15 2.17-1.92s.46 1.12 2.1.22l.2 1.12a7.58 7.58 0 01-3.46 2.09 1.74 1.74 0 00-.71-1.36z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".61",
  d: "M175.18 133.86s.88.45.93 1.14l.07.38s3.3-.63 3.68-1.38l-.16-1.16a1.7 1.7 0 01-1.51.54c-.78-.24-.63-.75-.63-.75l-2.38 1.23z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".61",
  d: "M182.18 134.85l-.3-.15 2.17-1.92s.46 1.12 2.1.22l.2 1.12a7.58 7.58 0 01-3.46 2.09 1.74 1.74 0 00-.71-1.36z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M178.36 96.2l-4.99-.27-4.67-.25a.72.72 0 01-.32-.37l-.28-.82-1.03-2.93-1.55-4.45a.76.76 0 01.12-.25l4.59.06 4.85.06a.56.56 0 01.5.49c.07.46 2 7.8 2 7.8a1.47 1.47 0 00.78.92z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".05",
  d: "M178.36 96.2l-4.99-.27-4.67-.25a.72.72 0 01-.32-.37l-.28-.82-1.03-2.93-1.55-4.45a.76.76 0 01.12-.25l4.59.06 4.85.06a.56.56 0 01.5.49c.07.46 2 7.8 2 7.8a1.47 1.47 0 00.78.92z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".05",
  d: "M178.34 94.71s.62 1.37 0 1.48l4.02.17s.44-.1.4-.43c-.07-.25-.21-.48-.4-.65l-3.84-.5-.18-.07z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M178.32 95.92c.1-.03.14-.2.1-.41-.05-.2-.17-.35-.26-.33-.09.02-.13.2-.09.4.05.21.16.36.25.34z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M177.56 96.2l-4.05-.17-4.67-.25a.7.7 0 01-.32-.38l-.29-.82 8.66.2c.12.52.34 1 .67 1.41z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M179.48 107.15s.43 3.52 1.4 4.25l-.3-4.14-1.1-.11zM185.71 106.06l.42 26.06 1.3-26.42-1.72.36z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M184.47 95.42a1 1 0 01-.66 0c.6-.16.48-1.6.48-1.6l.03.02.31.18s.02 1.26-.16 1.4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M179.82 108.97l-.7 23.22c.24-.01.47-.09.67-.22l1.1-20.57-1.07-2.43z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".13",
  d: "M170.22 86.93l-.16.36-2.64 4.56-.35-.29-1.55-4.45a.76.76 0 01.12-.25l4.58.07z"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "104.54",
  y1: "32.64",
  x2: "103.99",
  y2: "146.35",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: ".01",
  stopColor: "#fff",
  stopOpacity: ".4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#fff",
  stopOpacity: "0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "17644.4",
  y1: "-71501.4",
  x2: "17248.7",
  y2: "-19640.4",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: ".01",
  stopColor: "#fff",
  stopOpacity: ".4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#fff",
  stopOpacity: "0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "160.8",
  y1: "124.25",
  x2: "196.59",
  y2: "114.43",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#68E1FD",
  stopOpacity: "0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".02",
  stopColor: "#66DAF6",
  stopOpacity: ".04"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".18",
  stopColor: "#58A1BC",
  stopOpacity: ".39"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".35",
  stopColor: "#4D758F",
  stopOpacity: ".66"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".53",
  stopColor: "#45566F",
  stopOpacity: ".85"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".73",
  stopColor: "#40435C",
  stopOpacity: ".96"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".99",
  stopColor: "#3F3D56"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "181.8",
  y1: "94",
  x2: "157.1",
  y2: "95.12",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: "0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".91",
  stopOpacity: ".8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "179.96",
  y1: "81.47",
  x2: "184.03",
  y2: "81.47",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#ECC4D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".42",
  stopColor: "#EFD4D1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#F2EAC9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "2869.26",
  y1: "2003.06",
  x2: "2961.71",
  y2: "2326.06",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#ECC4D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".42",
  stopColor: "#EFD4D1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#F2EAC9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "5986.3",
  y1: "4362.72",
  x2: "6286.72",
  y2: "4362.72",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#ECC4D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".42",
  stopColor: "#EFD4D1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#F2EAC9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "11809.4",
  y1: "3597.57",
  x2: "11825.6",
  y2: "2851.9",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: "0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".91",
  stopOpacity: ".8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "4341.58",
  y1: "1291.33",
  x2: "4491.93",
  y2: "1291.33",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#ECC4D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".42",
  stopColor: "#EFD4D1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#F2EAC9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "1098.89",
  y1: "433.8",
  x2: "1106.05",
  y2: "433.8",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#ECC4D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".42",
  stopColor: "#EFD4D1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#F2EAC9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "4223.11",
  y1: "757",
  x2: "4376.15",
  y2: "757",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#ECC4D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".42",
  stopColor: "#EFD4D1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#F2EAC9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "178.57",
  y1: "135.49",
  x2: "176.75",
  y2: "132.05",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: ".36",
  stopColor: "#00272E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#69B9EB",
  stopOpacity: "0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "3341.01",
  y1: "2339.61",
  x2: "3307.89",
  y2: "2288.47",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: ".36",
  stopColor: "#00272E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#69B9EB",
  stopOpacity: "0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "763.21",
  y1: "879.13",
  x2: "781.97",
  y2: "904.6",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#ECC4D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".42",
  stopColor: "#EFD4D1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#F2EAC9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "165.51",
  y1: "89.35",
  x2: "170.22",
  y2: "89.35",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#68E1FD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#69B9EB"
})), /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h205.43v148.56H0z"
})))));